import { Container } from 'react-bootstrap';

function VisionMission() {
  return (
    <div>
      <Container fluid className="limited-width bg ogs-pri-text text-center py-5 mb-5">
        <h1 className="ogs-sec-text">Vision & Mission</h1>
      </Container>

      <Container fluid className="limited-width bg ogs-pri-text py-5mb-5">
        <h4 className="ogs-sec-text text-center mb-4 mt-4">Our Vision 👁️‍🗨️</h4>
        <p>
          To be a trusted <b className="ogs-high-text">multi-service partner</b> that empowers businesses and individuals with reliable technology and thoughtful solutions,
          enabling sustainable growth, smarter operations, and better experiences for the people who rely on them.
        </p>

        <h4 className="ogs-sec-text text-center mb-4 mt-5">Our Mission 🎯</h4>
        <ul>
          <li>Deliver high-quality, reliable, and tailored services that fit each client’s specific goals and way of working.</li>
          <li>Continuously innovate and adapt to the evolving technology landscape, staying ahead of the curve without adding unnecessary complexity.</li>
          <li>Build long-term partnerships based on integrity, transparency, and mutual respect, so clients know they can depend on us.</li>
          <li>Empower clients with clear guidance, honest feedback, and ongoing support, not just one-off project delivery.</li>
          <li>Maintain a positive, collaborative attitude – bringing good energy to every engagement while keeping the focus on outcomes.</li>
          <li>Do work we are proud of, so that our clients can be proud of the solutions they offer to their own customers.</li>
        </ul>

        <p>
          At OG Services, <b className="ogs-high-text">success</b> is measured not only by working software, but by how well it supports your people, your customers, and your long-term strategy.
          Our goal is to make technology feel like an <b className="ogs-high-text">asset</b>, not a hurdle.
        </p>
      </Container>
    </div>
  );
}

export default VisionMission;